(() => {
  'use strict';

  const configNode = document.getElementById('hsb-black-friday-data');
  if (!configNode || !document.body || document.documentElement.hasAttribute('data-hsb-bf-ready')) return;

  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  const references = config && typeof config.references === 'object' ? config.references : {};
  const money = cents => new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(cents / 100);
  const genericInstallments = 'Até 18x no cartão pelo Mercado Pago. Confira parcelas, total e disponibilidade no checkout.';
  const rendered = new WeakMap();
  const decorated = new WeakSet();
  const trackedPrices = new Set();
  const visitedPrices = new Set();
  let queued = false;

  const isBRL = () => config.currency === 'BRL' && (!window.Shopify?.currency?.active || window.Shopify.currency.active === 'BRL');
  const enabled = () => document.body.classList.contains('hsb-black-friday') && isBRL();
  const referenceFor = handle => {
    const value = Object.prototype.hasOwnProperty.call(references, handle) ? references[handle] : null;
    return value && Number.isSafeInteger(value.referenceCents) && Number.isSafeInteger(value.expectedCurrentCents)
      && value.expectedCurrentCents > 0 && value.referenceCents > value.expectedCurrentCents ? value : null;
  };
  const readCash = price => {
    const text = (price?.textContent || '').replace(/[\u00a0\u202f]/g, ' ').trim();
    const match = text.match(/^(?:A partir de\s+)?R\$\s*((?:\d{1,3}(?:\.\d{3})+|\d+)),(\d{2})(?:\s+à\s+vista)?$/i);
    if (!match) return null;
    const cents = Number(match[1].replace(/\./g, '')) * 100 + Number(match[2]);
    return Number.isSafeInteger(cents) && cents > 0 ? cents : null;
  };
  const dataCents = value => /^[1-9]\d*$/.test(String(value || '')) && Number.isSafeInteger(Number(value)) ? Number(value) : null;
  const removeReference = price => {
    const block = rendered.get(price);
    if (block) { block.remove(); rendered.delete(price); }
    trackedPrices.delete(price);
    if (decorated.has(price)) { price.classList.remove('hsb-bf-current-price'); decorated.delete(price); }
  };
  const renderReference = (price, handle, cashCents) => {
    if (!price) return false;
    visitedPrices.add(price);
    const value = referenceFor(handle);
    if (!enabled() || !value || cashCents !== value.expectedCurrentCents || readCash(price) !== cashCents) {
      removeReference(price);
      return false;
    }

    let block = rendered.get(price);
    if (!block?.isConnected) {
      block = document.createElement('div');
      block.className = 'hsb-bf-reference';
      block.setAttribute('data-hsb-bf-reference', '');
      rendered.set(price, block);
      trackedPrices.add(price);
    }
    const signature = `${handle}:${value.referenceCents}:${value.expectedCurrentCents}`;
    if (block.dataset.hsbBfSignature !== signature) {
      const oldPrice = document.createElement('p');
      oldPrice.className = 'hsb-bf-old-price';
      oldPrice.append(document.createTextNode('Referência do catálogo: '));
      const crossed = document.createElement('del');
      crossed.textContent = money(value.referenceCents);
      oldPrice.append(crossed);
      const saving = document.createElement('p');
      saving.className = 'hsb-bf-saving';
      saving.textContent = `Economia de ${money(value.referenceCents - value.expectedCurrentCents)}`;
      block.replaceChildren(oldPrice, saving);
      block.dataset.hsbBfSignature = signature;
    }
    if (price.previousElementSibling !== block) price.insertAdjacentElement('beforebegin', block);
    if (!price.classList.contains('hsb-bf-current-price')) {
      price.classList.add('hsb-bf-current-price');
      decorated.add(price);
    }
    return true;
  };
  const cardState = card => {
    const handle = card.dataset.handle || card.dataset.hsbHandle || '';
    const price = card.querySelector('.catalog-card-price');
    const cents = dataCents(card.dataset.price);
    return {handle, price, cents, valid: Boolean(price && cents !== null && readCash(price) === cents)};
  };
  const nativeVariantCents = root => {
    let native;
    try { native = JSON.parse(root.querySelector('[data-hsb-native-product]')?.textContent || '{}'); } catch { return null; }
    if (!Array.isArray(native.variants)) return null;
    const id = root.querySelector('[data-hsb-variant-select]')?.value || root.querySelector('input[name="id"]')?.value;
    const variant = id ? native.variants.find(item => String(item.id) === String(id))
      : native.variants.length === 1 ? native.variants[0] : null;
    return Number.isSafeInteger(variant?.price) && variant.price > 0 ? variant.price : null;
  };
  const renderHeroInstallments = (target, source) => {
    if (!target) return;
    const text = source?.textContent?.trim() || '';
    const complete = /^Simulação: 18x\b/.test(text) && text.includes('Total parcelado ') && text.includes('checkout');
    if (!complete) {
      if (target.textContent !== genericInstallments) target.textContent = genericInstallments;
      return;
    }
    if (target.textContent.trim() !== text) target.replaceChildren(...[...source.childNodes].map(child => child.cloneNode(true)));
  };

  const refresh = () => {
    queued = false;
    visitedPrices.clear();
    const cards = [...document.querySelectorAll('.catalog-card')];
    const validCards = new Map();
    cards.forEach(card => {
      const state = cardState(card);
      const shown = renderReference(state.price, state.handle, state.valid ? state.cents : null);
      if (shown && !validCards.has(state.handle)) validCards.set(state.handle, card);
    });
    document.querySelectorAll('[data-hsb-product-root]').forEach(root => {
      const price = root.querySelector('.catalog-product-panel .catalog-product-price');
      renderReference(price, root.dataset.productHandle || '', nativeVariantCents(root));
    });
    document.querySelectorAll('[data-hsb-consult-product]').forEach(root => {
      const price = root.querySelector('.catalog-product-panel .catalog-product-price');
      renderReference(price, root.dataset.hsbConsultProduct || '', readCash(price));
    });
    document.querySelectorAll('[data-hsb-bf-hero]').forEach(hero => {
      const handle = hero.dataset.hsbBfHero || '';
      const price = hero.querySelector('[data-hsb-bf-hero-price]');
      const shown = renderReference(price, handle, dataCents(hero.dataset.hsbBfCurrentCents));
      const source = shown ? validCards.get(handle)?.querySelector('[data-hsb-installments]') : null;
      renderHeroInstallments(hero.querySelector('[data-hsb-bf-hero-installments]'), source);
    });
    [...trackedPrices].forEach(price => { if (!visitedPrices.has(price)) removeReference(price); });
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(refresh);
  };
  const managedNode = node => {
    const element = node?.nodeType === Node.ELEMENT_NODE ? node : node?.parentElement;
    return Boolean(element?.closest('[data-hsb-bf-reference], [data-hsb-bf-hero-installments]'));
  };

  document.documentElement.setAttribute('data-hsb-bf-ready', '');
  refresh();
  if (typeof MutationObserver === 'function') {
    const observer = new MutationObserver(records => {
      const changed = records.some(record => {
        if (record.type === 'attributes') return record.attributeName !== 'class' || record.target === document.body;
        if (managedNode(record.target)) return false;
        const nodes = [...record.addedNodes, ...record.removedNodes];
        return !nodes.length || !nodes.every(managedNode);
      });
      if (changed) schedule();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'data-price', 'data-handle', 'data-hsb-handle', 'data-product-handle', 'data-hsb-consult-product', 'data-hsb-bf-current-cents']
    });
  }
  document.addEventListener('change', schedule, true);
  document.addEventListener('input', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
})();
